interface GetCohortDataProps {
  cohortName?: string
  cohorts: Array<{ name: string; data: string[] }>
  cohortSynonyms?: { [key: string]: string[] }
  chartType?: string
}

export default function getCohortData({
  cohortName,
  cohorts = [],
  cohortSynonyms,
  chartType,
}: GetCohortDataProps) {
  const synonyms = Object.entries(cohortSynonyms || {}).find(
    ([k]) => k.toLowerCase() == cohortName?.toLowerCase()
  )?.[1] as string[]
  if (synonyms) {
    return cohorts.find((cohort) => synonyms.includes(cohort.name))
  }
  if (cohortName) {
    const foundCohort = cohorts.find((cohort) => cohort.name === cohortName)
    // bug found in key ratings chart, not sure if we want this behavior for other chart types
    if (chartType === 'KeyRatingsRow' && cohortName !== 'None') {
      return foundCohort ? foundCohort : cohorts[0]
    }
    return foundCohort
  }
  return cohorts[0]
}
